import { render, staticRenderFns } from "./EventEditorProgramField.vue?vue&type=template&id=3db77bb0&"
import script from "./EventEditorProgramField.vue?vue&type=script&lang=js&"
export * from "./EventEditorProgramField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports